module.exports = __webpack_public_path__ + "img/will-distribution.f48246b2.svg";